import React from 'react';
import { usePopularNewsQuery } from '../hooks/useNewsListQuery';
import HorizontalNewsCarousel from './HorizontalNewsCarousel';

const PopularNewsSlider = ({ limit = 20 }) => {
  const {
    news: popularNews,
    initialLoading,
  } = usePopularNewsQuery(limit);

  return (
    <HorizontalNewsCarousel
      title="Популярні новини"
      news={popularNews}
      initialLoading={initialLoading}
      showViews
    />
  );
};

export default PopularNewsSlider;
